import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "d-sm-flex align-items-center" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "table-scroll-outer" }
const _hoisted_8 = { class: "table-scroll-mobile" }
const _hoisted_9 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_11 = { class: "ps-0" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_16 = {
  key: 1,
  class: "text-info"
}
const _hoisted_17 = { key: 2 }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "text-nowrap" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_23 = { style: {"word-wrap":"break-word","width":"50%"} }
const _hoisted_24 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_25 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_26 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_27 = { class: "dropdown" }
const _hoisted_28 = { class: "dropdown-menu" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { key: 1 }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center" }
const _hoisted_34 = { class: "mb-0 text-paragraph" }
const _hoisted_35 = { class: "fw-bold" }
const _hoisted_36 = { class: "fw-bold" }
const _hoisted_37 = { class: "fw-bold" }
const _hoisted_38 = { class: "mt-15 mt-md-0" }
const _hoisted_39 = { class: "pagination mb-0" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  class: "modal fade",
  id: "detailColisModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_42 = { class: "modal-dialog modal-dialog-centered modal-xl" }
const _hoisted_43 = { class: "modal-content p-15 p-md-40" }
const _hoisted_44 = { class: "modal-body" }
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-md-6" }
const _hoisted_47 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_48 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_49 = { class: "list-unstyled my-1" }
const _hoisted_50 = { class: "my-25" }
const _hoisted_51 = { class: "align-middle" }
const _hoisted_52 = { class: "align-middle" }
const _hoisted_53 = { class: "align-middle" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_56 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_57 = { class: "list-unstyled my-1" }
const _hoisted_58 = { class: "align-middle" }
const _hoisted_59 = { class: "my-25" }
const _hoisted_60 = { class: "align-middle" }
const _hoisted_61 = { class: "my-25" }
const _hoisted_62 = { class: "align-middle" }
const _hoisted_63 = { class: "my-25" }
const _hoisted_64 = { class: "align-middle" }
const _hoisted_65 = { class: "my-25" }
const _hoisted_66 = { class: "align-middle" }
const _hoisted_67 = { class: "my-25" }
const _hoisted_68 = { class: "align-middle" }
const _hoisted_69 = { class: "align-middle" }
const _hoisted_70 = { class: "align-middle" }
const _hoisted_71 = { class: "table table-sm table-bordered mt-20" }
const _hoisted_72 = { class: "td-nowrap" }
const _hoisted_73 = ["src"]
const _hoisted_74 = ["src"]
const _hoisted_75 = { class: "parcel-status td-nowrap" }
const _hoisted_76 = {
  key: 1,
  class: "dn-inv-table-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: "/add-colis-stock",
            class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode(" Nouveau Colis ", -1),
              _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
            ])),
            _: 1,
            __: [9]
          }),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: _ctx.selectedRows.length === 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendSelectedRows && _ctx.sendSelectedRows(...args)))
          }, " Prêt pour préparation les colis sélectionnés ", 8, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRecords())),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
            class: "form-control shadow-none text-black rounded-0"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("table", _hoisted_9, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_10, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectAll) = $event)),
                      onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args)))
                    }, null, 544), [
                      [_vModelCheckbox, _ctx.selectAll]
                    ])
                  ]),
                  _cache[10] || (_cache[10] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                  }, " Code d'envoi ", -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Destinataire ", -1)),
                  _cache[12] || (_cache[12] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Status ", -1)),
                  _cache[13] || (_cache[13] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Ville ", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Prix ", -1)),
                  _cache[15] || (_cache[15] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Date de création ", -1)),
                  _cache[16] || (_cache[16] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " Produits ", -1)),
                  _cache[17] || (_cache[17] = _createElementVNode("th", {
                    scope: "col",
                    class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                  }, " ACTIONS ", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        value: row.id,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRows) = $event))
                      }, null, 8, _hoisted_12), [
                        [_vModelCheckbox, _ctx.selectedRows]
                      ])
                    ]),
                    _createElementVNode("th", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        (row.replace === 1)
                          ? (_openBlock(), _createElementBlock("h6", _hoisted_15, [
                              _createTextVNode(_toDisplayString(row.code) + " ", 1),
                              _cache[18] || (_cache[18] = _createElementVNode("i", { class: "ph ph-repeat" }, null, -1))
                            ]))
                          : (row.partial === 1)
                            ? (_openBlock(), _createElementBlock("h6", _hoisted_16, [
                                _createTextVNode(_toDisplayString(row.code) + " ", 1),
                                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "ph ph-arrows-down-up" }, null, -1))
                              ]))
                            : (_openBlock(), _createElementBlock("h6", _hoisted_17, _toDisplayString(row.code), 1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("p", _hoisted_19, [
                        _createElementVNode("b", null, _toDisplayString(row.receiver), 1),
                        _cache[20] || (_cache[20] = _createTextVNode()),
                        _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("b", null, _toDisplayString(_ctx.oldPhone(row.phone)), 1),
                        _cache[22] || (_cache[22] = _createTextVNode()),
                        _cache[23] || (_cache[23] = _createElementVNode("br", null, null, -1))
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      (
                    row.status == 'WAITING_PICKUP' && row.delivery_note_s != 0
                  )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                            style: _normalizeStyle({ '--dynamic-bg': row.statut.code_color })
                          }, _toDisplayString(row.statut.s_name), 5))
                        : (row.stock_ready == 0)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                              style: _normalizeStyle({ '--dynamic-bg': row.statut.code_color })
                            }, _toDisplayString(row.statut.s_name), 5))
                          : (row.stock_ready == 1)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 2,
                                class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                                style: _normalizeStyle({ '--dynamic-bg': row.statut.code_color })
                              }, " Prêt pour la préparation ", 4))
                            : (_openBlock(), _createElementBlock("div", {
                                key: 3,
                                class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                                style: _normalizeStyle({ '--dynamic-bg': row.statut.code_color })
                              }, " Nouveau Colis ", 4))
                    ]),
                    _createElementVNode("td", _hoisted_21, [
                      _createElementVNode("b", null, _toDisplayString(row.city_name), 1)
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("b", null, _toDisplayString(row.price), 1),
                      _cache[24] || (_cache[24] = _createTextVNode("Dhs", -1)),
                      _cache[25] || (_cache[25] = _createElementVNode("br", null, null, -1)),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(row.product_nature), 1)
                    ]),
                    _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.getDate(row.created_at)), 1),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("b", null, _toDisplayString(row.nb_pros || 0), 1),
                      _cache[26] || (_cache[26] = _createTextVNode(" Produits ", -1))
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[31] || (_cache[31] = _createElementVNode("button", {
                          class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                          type: "button",
                          "data-bs-toggle": "dropdown",
                          "aria-expanded": "false"
                        }, [
                          _createElementVNode("i", { class: "flaticon-dots" })
                        ], -1)),
                        _createElementVNode("ul", _hoisted_28, [
                          (row.status == 'NEW_PARCEL')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                                _createVNode(_component_router_link, {
                                  to: `/edit-colis-stock/${row.id}`,
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);"
                                }, {
                                  default: _withCtx(() => _cache[27] || (_cache[27] = [
                                    _createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Ajouter Produits ", -1)
                                  ])),
                                  _: 2,
                                  __: [27]
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            _createElementVNode("button", {
                              class: "dropdown-item d-flex align-items-center",
                              onClick: ($event: any) => (_ctx.showDetails(row))
                            }, _cache[28] || (_cache[28] = [
                              _createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1),
                              _createTextVNode(" Infos ", -1)
                            ]), 8, _hoisted_30)
                          ]),
                          (row.status == 'NEW_PARCEL')
                            ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                                _createVNode(_component_router_link, {
                                  to: `/edit-colis/${row.id}/${row.code}`,
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);"
                                }, {
                                  default: _withCtx(() => _cache[29] || (_cache[29] = [
                                    _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1),
                                    _createTextVNode(" Modifier ", -1)
                                  ])),
                                  _: 2,
                                  __: [29]
                                }, 1032, ["to"])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("li", null, [
                            (row.nb_pros == 0)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  class: "dropdown-item d-flex align-items-center",
                                  href: "javascript:void(0);",
                                  onClick: ($event: any) => (_ctx.removeColis(row))
                                }, _cache[30] || (_cache[30] = [
                                  _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                  _createTextVNode(" supprimer", -1)
                                ]), 8, _hoisted_32))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("p", _hoisted_34, [
            _cache[32] || (_cache[32] = _createTextVNode(" Showing ", -1)),
            _createElementVNode("span", _hoisted_35, _toDisplayString((_ctx.filter.current_page - 1) * _ctx.filter.per_page + 1), 1),
            _cache[33] || (_cache[33] = _createTextVNode(" – ", -1)),
            _createElementVNode("span", _hoisted_36, _toDisplayString(Math.min(_ctx.filter.current_page * _ctx.filter.per_page, _ctx.filter.total)), 1),
            _cache[34] || (_cache[34] = _createTextVNode(" out of ", -1)),
            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.filter.total), 1),
            _cache[35] || (_cache[35] = _createTextVNode(" results ", -1))
          ]),
          _createElementVNode("nav", _hoisted_38, [
            _createElementVNode("ul", _hoisted_39, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Previous",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page - 1)))
                }, _cache[36] || (_cache[36] = [
                  _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                ]))
              ], 2),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.last_page, (page) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: page,
                  class: "page-item"
                }, [
                  _createElementVNode("a", {
                    href: "javascript:void(0)",
                    class: _normalizeClass(["page-link", { active: _ctx.filter.current_page === page }]),
                    onClick: ($event: any) => (_ctx.goToPage(page))
                  }, _toDisplayString(page), 11, _hoisted_40)
                ]))
              }), 128)),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item", { disabled: _ctx.filter.current_page === _ctx.filter.last_page }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  href: "javascript:void(0)",
                  "aria-label": "Next",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPage(_ctx.filter.current_page + 1)))
                }, _cache[37] || (_cache[37] = [
                  _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                ]))
              ], 2)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_41, [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _cache[56] || (_cache[56] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h1", { class: "modal-title fs-5" }, "Informations colis"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _cache[41] || (_cache[41] = _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
                    _createElementVNode("h5", { class: "mb-0" }, "Informarion Colis :")
                  ], -1)),
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("ul", _hoisted_49, [
                      _createElementVNode("li", _hoisted_50, [
                        _createElementVNode("span", _hoisted_51, [
                          _cache[38] || (_cache[38] = _createElementVNode("b", { class: "bclass" }, "Téléphone : ", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.magasin?.phone_store), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_52, [
                          _cache[39] || (_cache[39] = _createElementVNode("b", { class: "bclass" }, "Client :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.store), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_53, [
                          _cache[40] || (_cache[40] = _createElementVNode("b", { class: "bclass" }, "Responsable :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.customer_name), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("div", _hoisted_55, [
                  _cache[50] || (_cache[50] = _createElementVNode("div", { class: "card-header d-flex justify-content-between align-items-center" }, [
                    _createElementVNode("h5", { class: "mb-0" }, "Information Bon livraison")
                  ], -1)),
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("ul", _hoisted_57, [
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_58, [
                          _cache[42] || (_cache[42] = _createElementVNode("b", { class: "bclass" }, "Code d'envoie :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.code), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, [
                          _cache[43] || (_cache[43] = _createElementVNode("b", { class: "bclass" }, "Destinataire :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.receiver), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_61, [
                        _createElementVNode("span", _hoisted_62, [
                          _cache[44] || (_cache[44] = _createElementVNode("b", { class: "bclass" }, "Téléphone :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.phone), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_63, [
                        _createElementVNode("span", _hoisted_64, [
                          _cache[45] || (_cache[45] = _createElementVNode("b", { class: "bclass" }, "Ville :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.city_name), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_65, [
                        _createElementVNode("span", _hoisted_66, [
                          _cache[46] || (_cache[46] = _createElementVNode("b", { class: "bclass" }, "Adresse :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.address), 1)
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_67, [
                        _createElementVNode("span", _hoisted_68, [
                          _cache[47] || (_cache[47] = _createElementVNode("b", { class: "bclass" }, "Commentaire :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.note), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_69, [
                          _cache[48] || (_cache[48] = _createElementVNode("b", { class: "bclass" }, "Nature Produit :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.product_nature), 1)
                        ])
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("span", _hoisted_70, [
                          _cache[49] || (_cache[49] = _createElementVNode("b", { class: "bclass" }, "Crbt :", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.coliDetails?.price) + " DH", 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _cache[55] || (_cache[55] = _createElementVNode("hr", null, null, -1)),
            _createElementVNode("table", _hoisted_71, [
              _cache[54] || (_cache[54] = _createElementVNode("thead", null, [
                _createElementVNode("tr", { class: "dn-inv-table-head" }, [
                  _createElementVNode("th", null, "Photo"),
                  _createElementVNode("th", null, "Nom du produit"),
                  _createElementVNode("th", null, "Quantité")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_ctx.colisContents.length != 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.colisContents, (prod, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        class: "dn-inv-table-body",
                        key: index
                      }, [
                        _createElementVNode("td", _hoisted_72, [
                          (prod.product_pic && prod.product_pic != null)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                height: "50",
                                width: "50",
                                src: prod.product_pic
                              }, null, 8, _hoisted_73))
                            : (prod.product_pic == null)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  height: "50",
                                  width: "50",
                                  src: require('@/assets/images/NoImage.png')
                                }, null, 8, _hoisted_74))
                              : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_75, [
                          _createElementVNode("b", null, _toDisplayString(prod.product_name), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("b", null, _toDisplayString(prod.qnty) + " : ", 1),
                          _createTextVNode(" " + _toDisplayString(prod.variant_name), 1),
                          _cache[51] || (_cache[51] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode(" " + _toDisplayString(prod.product_name), 1),
                          _cache[52] || (_cache[52] = _createElementVNode("br", null, null, -1))
                        ])
                      ]))
                    }), 128))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_76, _cache[53] || (_cache[53] = [
                      _createElementVNode("td", {
                        colspan: "8",
                        style: {"text-align":"center"}
                      }, " Aucun produit trouvé. ", -1)
                    ])))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}